import {type RankedDivisionState} from '@colonist/leaderboard-types'
import {MathUtils} from '../../../../shared/utils/MathUtils.ts'
import {GameColor} from '../../../shared/scripts/GameColor.ts'
import {createDivIn} from '../../../shared/scripts/ui_utils/DomUtils.ts'

export class UIProfileRankedProgressBarController {
    private readonly progressBarIdBase = 'ranked_progress_bar'
    private readonly seasonProgress: RankedDivisionState
    private readonly currentSkill: number
    private readonly progressBarContainerDiv: HTMLDivElement
    private readonly progressBarDiv: HTMLDivElement

    constructor(seasonProgress: RankedDivisionState, currentSkill: number, progressContainerDiv: HTMLDivElement) {
        this.seasonProgress = seasonProgress
        this.currentSkill = currentSkill
        this.progressBarContainerDiv = createDivIn(progressContainerDiv, `${this.progressBarIdBase}_container`)
        this.progressBarDiv = createDivIn(this.progressBarContainerDiv, this.progressBarIdBase)

        const percentage = this.calculateProgressPercentage()
        this.fillProgressBar(percentage)
    }

    private calculateProgressPercentage(): number {
        const lowerBound = this.seasonProgress.demotionDivisionBoundary.boundary
        const upperBound = this.seasonProgress.promotionDivisionBoundary.boundary
        const percentage = MathUtils.calculatePercentage(Number(this.currentSkill), lowerBound, upperBound)
        return percentage
    }

    private fillProgressBar(percentage: number) {
        this.progressBarDiv.style.width = `${percentage}%`
        this.progressBarDiv.style.backgroundColor = GameColor.getColor(GameColor.Color.GreenDark)
    }
}
